import Web3 from "web3";

let web3 = new Web3(window.ethereum);
let web3Obj = new Web3(new Web3.providers.HttpProvider(`https://rinkeby.infura.io/v3/a426a5fbdadc47bf8a9683933ab79a78`));

export { web3, web3Obj };